import {
    ITEMS_FETCH_SUCCESS,
    CATEGORIES_FETCH_SUCCESS
} from '../action/actionType'

const initialState = {items: []}

function itemReducer(state = initialState, action){
    switch(action.type){
        case ITEMS_FETCH_SUCCESS:
            return {...state, items: action.payload};
        default:
            return state;
    }
}

export default itemReducer